import { pluralize } from '@lib/pluralize';
import { LocaleArgument, LocaleType, Translations } from './types';

export const translate = (key: string, locale: LocaleType, translations: Translations, args?: LocaleArgument) => {
    let result = translations[key][locale];

    if (Array.isArray(result)) {
        if (args) {
            const [count] = args;
            return pluralize(Number(count), result);
        } else {
            throw Error('Unknown key');
        }
    }
    if (args) {
        args.forEach((arg) => {
            if (typeof result === 'string') {
                result = result.replace('${}', String(arg));
            }
        });
        return result;
    }
    return result;
};
